import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'pop-over',
  templateUrl: './pop-over.component.html',
  styleUrls: ['./pop-over.component.scss']
})
export class PopOverComponent implements OnInit, AfterViewInit, OnDestroy {

  declareActive() {
    this.activePopovers[this._popoverId] = this;
  }
  declareInactive() {
    delete this.activePopovers[this._popoverId];
  }
  private readonly _popoverId: number = Date.now();
  private _show: boolean = false;

  @Input() set show(value: boolean) {
    this._show = value;
    if (value)
      this.open();
    else
      this.close();
  }

  @Input() title: string = 'Unknown - popover';
  @Input() position: 'center' | 'left' | 'right' | 'top' = 'center';
  @Input() closeOnEscape: boolean = true;
  @Input() allowOutsideClick: boolean = false;
  @Output() onClose: EventEmitter<unknown> = new EventEmitter();
  @Output() onOpen: EventEmitter<unknown> = new EventEmitter();
  @ViewChild('content') content: ElementRef;
  @ViewChild('popOver') popOver: ElementRef;

  overflow: 'auto' | 'hidden' = 'hidden';
  keyUpListener;
  previousTitle: string;

  constructor(
    public globalService: GlobalService,
    public titleService: Title
  ) { }

  ngOnInit(): void {
    // this.previousTitle = this.titleService.getTitle();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.overflow = 'auto';
    }, 800);
  }

  onEscape = (event: KeyboardEvent) => {
    const mostRecentPopoverId = Math.max(...Object.keys(this.activePopovers).map(key => +key));
    if (mostRecentPopoverId !== this._popoverId) return
    if (event.key === 'Escape') {
      this.close();
    }
  }

  listenForEscape() {
    if (this.closeOnEscape) {
      window.addEventListener('keyup', this.onEscape);
    }
  }

  public open() {
    document.body.style.overflow = 'hidden';
    this.overflow = 'hidden';
    this._show = true;
    // this.titleService.setTitle(this.title);
    this.declareActive();
    this.listenForEscape();
    this.onOpen.emit();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  close() {
    this._show = false;
    // this.titleService.setTitle(this.previousTitle);
    window.removeEventListener('keyup', this.onEscape);
    this.declareInactive();
    this.overflow = 'auto';
    if (!Object.keys(this.activePopovers).length)
      document.body.style.overflow = 'auto';
    this.onClose.emit();
  }

  get isOpen(): boolean {
    return this._show;
  }

  get activePopovers() {
    if (!window['_activePopovers']) window['_activePopovers'] = {};
    return window['_activePopovers'];
  }

  onOutsideClick(event: MouseEvent, content: HTMLDivElement) {
    if (!this.allowOutsideClick) return;
    const isOutsideClick = event.target === content;
    if (isOutsideClick) {
      this.close();
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener('keyup', this.onEscape);
    this.declareInactive();
    // this.titleService.setTitle(this.previousTitle);
    this.onClose.emit();
    if (!Object.values(this.activePopovers).length) {
      document.body.style.overflow = 'auto';
    }
  }

}
